import React, { useEffect, useState } from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { FormEditMembership } from "./FormEditMembership";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { useParams } from "react-router-dom";
import { CircularProgress, LinearProgress } from "@mui/material";

export const EditMembership = () => {
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [membershipData, setMembershipData] = useState(null);
    const [services, setServices] = useState([]);
    const [isServicesLoading, setIsServicesLoading] = useState(true);

    const fetchData = async () => {
        try {
            // Fetch membership details
            const { response: membershipResponse } = await Helper.Get({
                url: `${api_Routes.Membership.ViewUserDetails}${id}`,
            });

            // Fetch services
            const { response: servicesResponse } = await Helper.Get({
                url: api_Routes.MembershipService.ViewAll,
            });

            if (membershipResponse && servicesResponse) {
                setMembershipData({
                    ...membershipResponse.data,
                    is_active: Boolean(membershipResponse.data.is_active),
                    allow_multiple_months: Boolean(membershipResponse.data.allow_multiple_months),
                    services: membershipResponse.data.services?.map(s => s.id) || []
                });
                setServices(servicesResponse.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
            setIsServicesLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <PanelHead
                title={
                    isLoading ? (
                        <div className="flex items-center gap-4">
                            Edit Membership <CircularProgress size={24} />
                        </div>
                    ) : (
                        <div className="flex items-center justify-between w-full gap-4">
                            <div>Edit Membership: {membershipData?.name}</div>
                        </div>
                    )
                }
            />
            <PanelBody
                content={
                    isLoading ? (
                        <LinearProgress />
                    ) : (
                        <FormEditMembership
                            membershipData={membershipData}
                            setMembershipData={setMembershipData}
                            services={services}
                            isServicesLoading={isServicesLoading}
                        />
                    )
                }
            />
        </div>
    );
};